import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import LoadingScreen from './LoadingScreen';

// Rutas públicas (login/registro): si ya hay una sesión, no tiene sentido
// seguir viéndolas. Redirige a "/", que es quien decide entre InicioPage y
// la pantalla de "acceso no habilitado" según el perfil — así se evita
// cualquier loop entre "/" y "/login".
function PublicRoute({ children }) {
  const { loading, user } = useAuth();

  if (loading) {
    return <LoadingScreen />;
  }

  if (user) {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default PublicRoute;
